
import React from 'react';
import { Alert as AntAlert } from 'antd';

export const Alert = props => <AntAlert {...props} />;
